import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule, type IconDefinition } from '@fortawesome/angular-fontawesome';
import { faAlignLeft } from '@fortawesome/pro-regular-svg-icons';
import { CssUrlPipe } from '@reconcept-platform/shared/util';

export interface ContentTilePreview {
  icon?: IconDefinition;
  imageUrl?: string;
  backgroundColor?: string;
  color?: string;
}

export type ContentPreviewSize = 'large' | 'huge' | 'full-width';

@Component({
  selector: 'rcp-content-tile-preview',
  template: `
    <div
      class="preview__container"
      [class.huge]="size() === 'huge'"
      [style.background-color]="preview()?.backgroundColor"
      [style.color]="preview()?.color"
    >
      @if (preview()?.imageUrl; as imageUrl) {
        <div class="preview__thumbnail" [style.background-image]="imageUrl | cssUrl"></div>
      } @else if (preview()?.icon; as icon) {
        <fa-icon [icon]="icon" class="preview__icon" [style.color]="preview()?.color" />
      } @else if (!isVideo()) {
        <fa-icon [icon]="faAlignLeft" class="preview__icon" />
      }
      @if (isVideo()) {
        <img src="/assets/video-play.svg" class="preview__video-indicator" />
      }
    </div>
  `,
  styleUrl: './content-tile-preview.component.scss',
  imports: [FontAwesomeModule, CssUrlPipe],
  host: {
    '[class.full-width]': "size() === 'full-width'",
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ContentTilePreviewComponent {
  isVideo = input(false);
  readonly size = input<ContentPreviewSize>('large');
  readonly preview = input<ContentTilePreview>();

  protected readonly faAlignLeft = faAlignLeft;
}
